'use client';

import { useTheme } from 'next-themes';
import { useHydrated } from '@/hooks/ui/use-hydrated';
export type AppliedTheme = 'light' | 'dark';

/**
 * The theme actually painted on `<html>`: `forcedTheme` when a route forces one
 * (the dark-only marketing landing, see `AppThemeProvider`), otherwise the
 * user's resolved preference.
 *
 * next-themes' `resolvedTheme` deliberately ignores `forcedTheme`, so a
 * component that branches on it in JS (logo / asset / colour swaps) mismatches a
 * forced page. A forced theme is deterministic on the server, so it needs no
 * hydration gate; the preference path keeps the gate to avoid a hydration
 * mismatch (the server has no `resolvedTheme`).
 */
export function useAppliedTheme() {
  const {
    forcedTheme,
    resolvedTheme
  } = useTheme();
  const hydrated = useHydrated();
  const theme = forcedTheme ?? (hydrated ? resolvedTheme : undefined);
  return theme === "dark" || theme === "light" ? theme : undefined;
}